import React from 'react';
import { useParams } from 'react-router-dom';
import { CreativePreferences as SharedCreativePreferences } from '@egreact/shared';
import BookingFormTabs, { CHROME_SELECTOR, CREATIVE } from '../../components/BookingFormTabs/BookingFormTabs';
import StoreToken from '../../components/StoreToken';
import './configure';

// The client fills the form here, so nothing is forced read-only: the payload
// and the query string still decide, as they did before the move.
const CreativePreferences = () => {
  const { booking_id: bookingId } = useParams();
  return (
    <SharedCreativePreferences
      useStoreToken={StoreToken}
      // The navbar with the booking's form tabs under it.
      chrome={<BookingFormTabs bookingId={bookingId} active={CREATIVE} />}
      navSelector={CHROME_SELECTOR}
    />
  );
};

export default CreativePreferences;
